module.exports = __webpack_public_path__ + "static/media/AZ.94485346.svg";